export default "__VITE_ASSET__DosO3dHr__"